import React, { forwardRef } from "react";
import { TextField } from "@mui/material";

const CustomTextField = forwardRef(({
  label,
  value,
  onChange,
  name,
  type = "text",
  placeholder,
  style = {},
  ...props
}, ref) => {
  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={onChange}
      name={name}
      type={type}
      placeholder={placeholder}
      inputRef={ref}
      sx={{
        '& .MuiInputBase-root': {
          height: '56px',
          fontSize: 14,
        },
        '& .MuiInputBase-input': {
          padding: '14px',
        },
        '& .MuiInputLabel-root': {
          fontSize: 15,
        },
        '& .MuiFormHelperText-root': {
          fontSize: 12,
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px) scale(0.75)',
          backgroundColor: 'white',
          padding: '0 4px',
        },
        ...style,
      }}
      {...props}
    />
  );
});

export default CustomTextField;
